import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDeveloppeurMobile = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          📱 Recruter un Développeur Mobile
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Développeur Mobile conçoit des applications destinées aux smartphones et tablettes, sur iOS, Android ou via des frameworks multiplateformes. Il transforme les idées en expériences utilisateurs mobiles performantes, intuitives et adaptées aux usages modernes. Son rôle est essentiel pour toucher un public toujours plus mobile.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Développer des applications mobiles natives (Swift, Kotlin) ou hybrides (Flutter, React Native)</li>
          <li>Intégrer les interfaces graphiques selon les maquettes fournies</li>
          <li>Implémenter des fonctionnalités spécifiques : notifications, géolocalisation, paiement, etc.</li>
          <li>Optimiser les performances et la consommation de ressources</li>
          <li>Effectuer les tests, corrections de bugs et mises à jour</li>
          <li>Publier les apps sur l’App Store et Google Play</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : Dart (Flutter), Java/Kotlin (Android), Swift (iOS), React Native</li>
          <li>Outils : Android Studio, Xcode, Firebase, Git</li>
          <li>Connaissance des guidelines Apple/Google, responsive mobile, sécurité mobile</li>
          <li>Intégration d’API, gestion des permissions, data offline</li>
          <li>UX mobile, animations, gestuelles, performances</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : maîtrise d’un framework mobile, apps simples ou MVP</li>
          <li>Confirmé : applications en production, gestion des stores, intégrations complexes</li>
          <li>Senior : pilotage d’un projet mobile complet, optimisation, architecture multi-plateformes</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–600 € / jour</li>
          <li>Senior : 650–800 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDeveloppeurMobile;
